import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { Injectable } from "@angular/core";
import { TokenDAO } from "@app/core/shared/data/local/token.dao";

@Injectable({
  providedIn: "root",
})
export class TokenDataRepo implements TokenRepo {
  private temporalToken: string | null = null;

  constructor(private tokenDAO: TokenDAO) {}

  get(): string | null {
    return this.tokenDAO.get();
  }

  save(token: string): void {
    this.tokenDAO.save(token);
  }

  remove() {
    this.tokenDAO.remove();
  }

  saveTemporal(token: string): void {
    this.temporalToken = token;
  }

  getTemporal(): string | null {
    return this.temporalToken;
  }

  removeTemporal(): void {
    this.temporalToken = null;
  }
}
